/**
 * Module dependencies.
 */

import { NextPage } from 'next/types';
import Legal from 'src/components/legal';
import useTranslate from 'src/hooks/use-translate';

/**
 * `TermsConditions` page.
 */

const TermsConditions: NextPage = () => {
  const { translate } = useTranslate();

  return (
    <Legal
      subtitle={translate('terms-conditions:subtitle')}
      text={translate('terms-conditions:text')}
      title={translate('terms-conditions:title')}
    />
  );
};

/**
 * Export `TermsConditions` page.
 */

export default TermsConditions;
